/** Limita também APIs que não aceitam AbortSignal (canvas e renderizador do PDF). */
export async function comPrazoPdf<T>(operacao: Promise<T>, prazoMs: number, mensagem: string): Promise<T> {
  let timer: ReturnType<typeof setTimeout> | undefined;
  try {
    return await Promise.race([
      operacao,
      new Promise<never>((_, reject) => {
        timer = setTimeout(() => reject(new Error(mensagem)), prazoMs);
      }),
    ]);
  } finally {
    clearTimeout(timer);
  }
}

/** O prazo cobre cabeçalhos E leitura do corpo; aborta a conexão ao terminar. */
export async function buscarParaPdf<T>(
  url: string, init: RequestInit, ler: (response: Response) => Promise<T>,
  prazoMs: number, mensagem: string,
): Promise<T> {
  const controller = new AbortController();
  try {
    return await comPrazoPdf(fetch(url, { ...init, signal: controller.signal }).then(ler), prazoMs, mensagem);
  } finally {
    controller.abort();
  }
}
